import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FilterCheckboxOptionModel } from "apps-module/app/shared-library/models/filter-checkbox-option.model";
import _cloneDeep from "lodash/cloneDeep";

@Component({
    selector: "[pcg-ng-facilities-filter]",
    templateUrl: "./facilities-filter.component.html"
})
export class FacilitiesFilterComponent {

    public control: FormControl<Array<string>> = null;
    @Input("control")
    public set controlSetter(value: FormControl<Array<string>>) {
        this.control = value;
    }

    public facilities: Array<FilterCheckboxOptionModel> = [];
    @Input("facilities")
    public set facilitiesSetter(value: Array<string>) {
        value = value || [];
        this.facilities = value.map(x => {
            return { checked: this.control.value.includes(x), value: x } as FilterCheckboxOptionModel;
        });
    }

    @Output()
    public onSelect = new EventEmitter();

    public onToggle(option: FilterCheckboxOptionModel): void {
        if (option.checked) {
            this.control.value.push(option.value);
        } else {
            this.control.value.splice(this.control.value.indexOf(option.value), 1);
        }

        this.onSelect.emit();
    }
}

